import { Access } from 'hooks/data/files/types';

export const checkAccessToResource = (access: Access | undefined, resourceKey: string, ver: string): boolean =>
  access?.[ver]?.includes(resourceKey) ?? false;
